import fetcher, { setAccountToHeader } from 'api/fetcher';
import { push } from 'connected-react-router';
import { changeAccount, setCurrentAccountIdToStorages } from 'utils/clickme';
import { Settings, SettingsConfig } from 'utils/constants/dynamicSettings';
import { Methods } from 'utils/constants/methods';
import { NotificationName } from 'utils/constants/notification';
import { getDashboardRoute } from 'utils/dashboardRoute';
import { getSettingsValue } from 'utils/settings';

import { setDynamicSettings } from 'store/autoReducers';
import { addNotification } from 'store/models/notification';
import { AppDispatch, AppThunkAction } from 'store/utils';

const fetchSettings = (dispatch: AppDispatch): Promise<string> => {
    return fetcher
        .get<unknown, Partial<SettingsConfig>>(Methods.Settings)
        .then((settings) => {
            dispatch(setDynamicSettings(settings));

            return getDashboardRoute(getSettingsValue(Settings.CampaignsDashboardRedesignAllowed, settings) as boolean);
        })
        .catch(() => getDashboardRoute(false));
};

export const fetchSudo = (userId: number, accountId: number | null, setIsLoadingOff?: () => void): AppThunkAction => {
    return (dispatch) => {
        return fetcher
            .get(`/api/v1/session/sudo/${userId}`)
            .then(() => {
                setCurrentAccountIdToStorages(accountId ? String(accountId) : '');

                if (accountId) {
                    setAccountToHeader(accountId.toString());
                }

                return fetchSettings(dispatch);
            })
            .then((dashboardRoute) => {
                if (accountId) {
                    changeAccount(accountId.toString(), dashboardRoute);
                } else {
                    dispatch(push(dashboardRoute));
                }
            })
            .catch(() => {
                setIsLoadingOff?.();
                dispatch(addNotification(NotificationName.UsersPageErrorSomethingWentWrong));
            });
    };
};
